module.exports = __webpack_public_path__ + "static/media/vote-done.1ea27fad.png";